// extracted by mini-css-extract-plugin
export default {"imageSlider__container":"styles_image-slider__container__iTvGw"};